<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-muted text-center mb-3">
                <small>用户 登陆</small>
              </div>
              <!-- <div class="btn-wrapper text-center">
                                <base-button type="neutral">
                                    <img slot="icon" src="img/icons/common/github.svg">
                                    Github
                                </base-button>

                                <base-button type="neutral">
                                    <img slot="icon" src="img/icons/common/google.svg">
                                    Google
                                </base-button>
                            </div> -->
            </template>
            <template>
              <!--   <div class="text-center text-muted mb-4">
                                <small>Or sign in with credentials</small>
                            </div> -->
              <form role="form" @keyup.enter="handleSubmit">
                <base-input
                  alternative
                  class="mb-3"
                  placeholder="登陆邮箱"
                  v-model.trim="form.email"
                  :error="emailerr"
                  addon-left-icon="ni ni-email-83"
                >
                </base-input>
                <base-input
                  alternative
                  type="password"
                  placeholder="登陆密码"
                  :error="passerr"
                  v-model="form.password"
                  addon-left-icon="ni ni-lock-circle-open"
                >
                </base-input>
                <base-checkbox> Remember me </base-checkbox>
                <div class="text-center">
                  <base-button
                    type="primary"
                    class="my-4"
                    :disabled="loading"
                    @click="handleSubmit"
                  >
                    <span
                      v-if="loading"
                      aria-hidden="true"
                      class="spinner-grow spinner-grow-sm"
                    ></span>
                    用户 登陆
                  </base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <router-link class="text-light" to="/recover">
                <small>忘记密码?</small>
              </router-link>
            </div>
            <div class="col-6 text-right">
              <router-link class="text-light" to="/register">
                <small>注册新用户</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'LoginForm',
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      loading: false,
      passerr: '',
      emailerr: '',
    }
  },
  watch: {
    'form.email': function (value) {
      const pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      this.emailerr = ''
      if (!pattern.test(value)) {
        this.emailerr = '登陆邮箱格式有误，请核对！'
      } else {
        this.emailerr = ''
      }
    },
  },
  methods: {
    ...mapActions(['handleLogin', 'getUserInfo']),
    handleSubmit() {
      const { email, password } = this.form
      const pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      this.emailerr = ''
      this.passerr = ''
      if (!pattern.test(email)) {
        this.emailerr = '登陆邮箱格式有误，请核对！'
        return
      }
      if (!password) {
        this.passerr = '登陆密码不能为空，请核对！'
        return
      }
      this.loading = true
      this.handleLogin({ email: email.toLowerCase(), password })
        .then((res) => {
          this.getUserInfo().then((res) => {
            this.$router.push({
              name: this.$config.homeName,
            })
          })
        })
        .catch((err) => {
          this.loading = false
        })
    },
    passwordChange(val) {},
    getError(val) {
      let error = ''
      if (!this.form[val]) {
        error = '此字段为必填！'
      }
      return error
    },
  },
  // methods: {
  //   handleSubmit () {
  //     this.$refs.loginForm.validate((valid) => {
  //       if (valid) {
  //         this.$emit('on-success-valid', {
  //           email: this.form.email,
  //           password: this.form.password
  //         })
  //       }
  //     })
  //   }
  // }
}
</script>
<style>
</style>
